import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref([])
  let nextId = 1

  // 添加通知
  const add = (options) => {
    const notification = {
      id: nextId++,
      type: options.type || 'info', // success, error, warning, info
      title: options.title || null,
      message: options.message || '',
      duration: options.duration || 4000,
      autoClose: options.autoClose !== false, // 預設自動關閉
      ...options
    }

    notifications.value.push(notification)
    
    // 限制最大通知數量，避免堆疊過多
    if (notifications.value.length > 5) {
      notifications.value.shift() // 移除最舊的通知
    }

    return notification.id
  }

  // 移除指定通知
  const remove = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  // 清空所有通知
  const clear = () => {
    notifications.value = []
  }

  // 便捷方法
  const success = (message, options = {}) => {
    return add({
      type: 'success',
      message,
      ...options
    })
  }

  const error = (message, options = {}) => {
    return add({
      type: 'error',
      message,
      duration: 6000, // 錯誤訊息顯示久一點
      ...options
    })
  }

  const warning = (message, options = {}) => {
    return add({
      type: 'warning',
      message,
      ...options
    })
  }

  const info = (message, options = {}) => {
    return add({
      type: 'info',
      message,
      ...options
    })
  }

  return {
    notifications,
    add,
    remove,
    clear,
    success,
    error,
    warning,
    info
  }
})